import React, { useEffect, useState, useRef } from "react";
import { useSelector } from "react-redux";
import axiosInstance from '../axiosInstance';
import { useParams, useNavigate, useLocation } from "react-router-dom";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { FaPen, FaPlus, FaCheckCircle } from 'react-icons/fa';
import { FiArrowLeft } from "react-icons/fi";
import { API_URL_All } from "../api";
import * as general from '../libs/general';
import AdLayout from '../components/AdLayout';
import DataTable from '../components/ui/DataTable';
import "../css/DepartmentDetail.css";
import { StarRating, LockingTicket } from '../components/tickets/Tickets';
import Paging from '../components/Paging';
import ProductEditor from '../components/products/ProductEditor';
import VoteEditor from '../components/providers/VoteEditor';
import {
  fetchProviderMenuPermissions,
  fetchProviderRatingCommentPermissions,
} from "../libs/customerCreatePermission";

const Provider = () => {
  const { id } = useParams();
  const config = general.getLocalStorage("user_config");
  const currentUser = useSelector((state) => state.user.user);
  const isAdmin = currentUser?.isAdmin === true;
  const navigate = useNavigate();
  const [model, setModel] = useState({});
  const [activeTab, setActiveTab] = useState('tab1');

  const [loaded, setLoaded] = useState(false);
  const [pageOrderData, setPageOrderData] = useState({ content: [] });
  const [errorMessage, setErrorMessage] = useState("");

  const [pageData, setPageData] = useState({ content: [] });
  const [pageCommentsData, setPageCommentsData] = useState({ content: [] });
  const [comments, setComments] = useState([]);

  const [message, setMessage] = useState("");
  const hasRun = useRef(false);
  const [productEditorData, setProductEditorData] = useState(null);
  const [voteEditorData, setVoteEditorData] = useState(null);
  const [providerFeaturePerm, setProviderFeaturePerm] = useState({
    loaded: false,
    canView: false,
    canCreate: false,
    canEdit: false,
  });
  /** Đánh giá / bình luận & Vote — theo phân quyền «SẢN PHẨM / Đánh giá - bình luận». */
  const [ratingCommentPerm, setRatingCommentPerm] = useState({
    loaded: false,
    canPost: true,
  });
  const [providerAccess, setProviderAccess] = useState("allowed");
  const [adminUsers, setAdminUsers] = useState([]);

  const location = useLocation();

  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        const response = await axiosInstance.get("/api/users/searchAdminUsers", {
          params: { page: 0, size: 500, keyword: "" },
        });
        if (!cancelled) {
          setAdminUsers(response?.data?.page?.content || []);
        }
      } catch {
        if (!cancelled) setAdminUsers([]);
      }
    })();
    return () => {
      cancelled = true;
    };
  }, []);

  useEffect(() => {
    let cancelled = false;
    const isNewProvider = !(id && Number(id) > 0);
    setProviderFeaturePerm({
      loaded: false,
      canView: false,
      canCreate: false,
      canEdit: false,
    });
    setRatingCommentPerm({ loaded: false, canPost: true });
    setProviderAccess("allowed");

    (async () => {
      const [p, rc] = await Promise.all([
        fetchProviderMenuPermissions(axiosInstance),
        fetchProviderRatingCommentPermissions(axiosInstance),
      ]);
      if (cancelled) return;
      setRatingCommentPerm({
        loaded: true,
        canPost: Boolean(rc.canCommentVote),
      });
      setProviderFeaturePerm({
        loaded: true,
        canView: Boolean(p.canView),
        canCreate: Boolean(p.canCreate),
        canEdit: Boolean(p.canEdit),
      });

      if (isNewProvider && !p.canCreate) {
        setProviderAccess("denied");
        return;
      }
      if (!isNewProvider && !(p.canView || p.canEdit)) {
        setProviderAccess("denied");
        return;
      }

      fetchOneRecord(id);
      searchProducts({ referId: id });
      searchHistories({ referId: id });
      searchComments({ referId: id });
    })();

    return () => {
      cancelled = true;
    };
  }, [id]);

  function getOrderIdFromUrl() {
    const match = window.location.hash.match(/\?(.*)$/);
    var queryString = match ? match[1] : '';
    const params = new URLSearchParams(queryString);
    var orderId = params.get('orderId');
    return orderId;
  }

  const checkOpenVoteEditor = (id, providerName) => {

    const orderId = getOrderIdFromUrl();
    if (general.isNumber(orderId)) {
      setActiveTab('tab4');
      var obj = {
        id: 0,
        providerId: id,
        orderId: orderId,
        providerName: providerName
      };
      openVoteEditor(obj);
    }
  }
  const fetchOneRecord = async (id) => {
    if (!id) id = 0;
    setModel({});
    try {
      var urlApi = `/api/providers/getProvider?id=${id}`;
      const response = await axiosInstance.get(urlApi);

      if (!response.data?.success) {
        toast.error(response.data?.message || "Không tải được nhà cung cấp.");
        return;
      }

      var obj = response.data.data;
      if (!obj || typeof obj !== "object") {
        toast.error("Không tải được dữ liệu nhà cung cấp.");
        return;
      }

      const isNew = !id || Number(id) <= 0;
      if (isNew && !obj.careId && config?.userId) {
        obj.careId = config.userId;
        obj.careName = config.name || config.code || "";
      }

      setModel(obj);

      checkOpenVoteEditor(id, obj.name);

    } catch (error) {
      console.error(error);
      setModel({ error: error.message });
      toast.error(error.message);
    }
  };

  const buildCommentTree = (comments) => {
    const topLevel = comments.filter(c => !c.parentId);
    const replies = comments.filter(c => c.parentId);

    return topLevel.map(comment => ({
      ...comment,
      children: replies.filter(r => r.parentId === comment.id),
    }));
  };

  const handleActiveTab = async (tabName) => {
    setActiveTab(tabName);
    //searchProducts();
  }


  const handleSubmitForm = async (e) => {
    e.preventDefault();
    const isNewProvider = !(id && Number(id) > 0);
    const canSubmitWrite =
      providerFeaturePerm.loaded &&
      (isNewProvider ? providerFeaturePerm.canCreate : providerFeaturePerm.canEdit);
    if (!canSubmitWrite) {
      toast.warning("Bạn không có quyền cập nhật.");
      return;
    }
    var errorTag = e.currentTarget.querySelector('.error-msg');
    if (errorTag) return;

    const formData = new FormData();
    for (const key in model) {
      if (model.hasOwnProperty(key) && model[key] !== undefined && model[key] !== null) {
        formData.append(key, model[key]);
      }
    }

    var fileTag = document.querySelector('[data-select-for="FilePath"]');
    const file = fileTag.files[0];
    if (file) {
      formData.set('file', file);
    }

    try {
      var requestApi = `/api/providers/saveProvider`;
      const response = await axiosInstance.post(requestApi, formData, { 'Content-Type': 'multipart/form-data', });

      if (!response.data.success) {
        general.showFormError('.form_validate', response.data);
        console.log(response.data);
        return;
      }
      console.log(response);
      toast.success(response.data.message);
      const savedId = Number(response.data.data);
      if (savedId > 0 && !(id && Number(id) > 0)) {
        navigate(`/provider/${savedId}`);
      } else if (savedId > 0) {
        fetchOneRecord(savedId);
      } else {
        fetchOneRecord(id);
      }

    } catch (error) {
      toast.error(error.message);
    }

  };

  const handleChangeItemsPerPage = (e) => {
    const newItemsPerPage = parseInt(e.target.value, 10);
    searchProducts({ page: 0, size: newItemsPerPage });
  };

  const handlePageChange = (page) => {
    searchProducts({ page: page - 1 });
  };

  const handleOrderPageChange = (page) => {
    searchHistories({ page: page - 1 });
  };
  const handleOrderSizeChange = (e) => {
    const newSize = parseInt(e.target.value, 10);
    searchHistories({ page: 0, size: newSize });
  };

  const refreshTabComment = (e) => {

    fetchOneRecord(id);
    searchComments();
  };
  const handleSearchChange = (e) => {
    var searchValue = e.target.value;
    searchProducts({ page: 0, keyword: searchValue });
    //setSearchQuery(e.target.value);
  };

  const searchProducts = async (filter) => {
    if (window.calling) return;
    window.calling = true;
    setLoaded(false);
    setMessage('');
    setPageData({ content: [] });
    var params = general.getSession('search_products1');

    //var formData = general.getFormData('.form_filter');
    //Object.assign(params, formData);
    params.referId = model.id;

    if (!hasRun.current) {
      hasRun.current = true;
      var oldParams = general.getSession('search_products1');
      Object.assign(params, oldParams);
    }

    if (filter) Object.assign(params, filter);
    general.setSession('search_products1', params);
    window.initializeFilterValue(params);

    var filteredParams = Object.fromEntries(Object.entries(params).filter(([key, v]) => v !== undefined && v !== '' && key + v !== 'page0' && key + v !== 'size550' && key + v !== 'isDeletedfalse'));

    var response = {};
    try {
      response = await axiosInstance.get(`/api/products/searchProducts`, { params: filteredParams });
      setPageData(response.data);
    } catch (error) {
      setPageData({ content: [] });
      setMessage(error.message);
      console.error(error);
      toast.error(error.message);
    } finally {
      setLoaded(true);
      window.calling = false;
    }
  };

  const searchHistories = async (filter) => {
    if (window.calling2) return;
    window.calling2 = true;
    setMessage('');
    setPageOrderData({ content: [] });
    var params = general.getSession('search_products1');

    //var formData = general.getFormData('.form_filter');
    //Object.assign(params, formData);
    params.referId = model.id;

    if (!hasRun.current) {
      hasRun.current = true;
      var oldParams = general.getSession('search_products1');
      Object.assign(params, oldParams);
    }

    if (filter) Object.assign(params, filter);
    general.setSession('search_products1', params);
    window.initializeFilterValue(params);

    var filteredParams = Object.fromEntries(Object.entries(params).filter(([key, v]) => v !== undefined));

    var response = {};
    try {
      response = await axiosInstance.get('/api/providers/searchHistoryOrdersByProvider', { params: filteredParams });
      setPageOrderData(response.data);
    } catch (error) {
      setPageOrderData({ content: [] });
      setMessage(error.message);
      console.error(error);
      toast.error(error.message);
    } finally {
      window.calling2 = false;
    }
  };

  const searchComments = async (filter) => {
    if (window.calling3) return;
    window.calling3 = true;
    setMessage('');
    setPageCommentsData({ content: [] });
    var params = general.getSession('searchComments');
    params.referId = model.id;

    if (!hasRun.current) {
      hasRun.current = true;
      var oldParams = general.getSession('searchComments');
      Object.assign(params, oldParams);
    }

    if (filter) Object.assign(params, filter);

    var response = {};
    try {
      response = await axiosInstance.get('/api/providers/searchComments', { params: params });
      setPageCommentsData(response.data);
      var tree = buildCommentTree(response.data.page.content);
      setComments(tree);
    } catch (error) {
      setPageCommentsData({ content: [] });
      setMessage(error.message);
      console.error(error);
      toast.error(error.message);
    } finally {
      window.calling3 = false;
    }
  };
  const openProductEditor = (id) => {
    var obj = { id: id };
    if (id === 0) {
      obj.productType = 'share';
      obj.id = id;
      obj.providerId = model.id;
      obj.providerName = model.name;
    }
    setProductEditorData(obj);
  };
  const openVoteEditor = (obj) => {
    if (ratingCommentPerm.loaded && !ratingCommentPerm.canPost) {
      toast.warning("Bạn không có quyền đánh giá và bình luận nhà cung cấp.");
      return;
    }
    if (!obj) obj = { id: 0 };
    const orderId = new URLSearchParams(location.search).get('orderId');
    if (general.isNumber(orderId)) obj.orderId = model.orderId;
    if (model.id) obj.providerId = model.id;
    if (model.name) obj.providerName = model.name;

    setVoteEditorData(obj);
  };

  const handleOpenPDF = (filePath) => {
    var pdfUrl = API_URL_All + '/' + filePath;

    window.open(pdfUrl, '_blank');
  };
  function getWeightSize(weight, feeWeight, size, feeSize) {
    if (feeSize > feeWeight) return size.toLocaleString("vi-VN") + ' m3';
    if (!weight) return "";
    return weight.toLocaleString("vi-VN") + ' kg';
  };

  const handleDeletProvider = (e) => {
    general.openConfirm(async () => {
      try {
        var requestApi = `/api/providers/deleteProvider?id=${model.id}`;
        const response = await axiosInstance.get(requestApi);

        if (!response.data.success) {
          toast.error(response.data.message);
          return;
        }
        toast.success(response.data.message);
        navigate(general.popUrl());

      } catch (error) {
        console.error(error);
        toast.error(error.message);
      }
    },"Bạn có chắc chắn đã ngừng hợp tác với nhà cung cấp này không?")
  };

  const isNewProvider = !(id && Number(id) > 0);
  const formWritable =
    providerFeaturePerm.loaded &&
    (isNewProvider ? providerFeaturePerm.canCreate : providerFeaturePerm.canEdit);
  const canEditCarePerson = formWritable && isAdmin;
  const carePersonDisplayName =
    model.careName ||
    adminUsers.find((u) => Number(u.id) === Number(model.careId))?.name ||
    adminUsers.find((u) => Number(u.id) === Number(model.careId))?.username ||
    (model.careId ? `User #${model.careId}` : "—");
  /** Không được phân quyền «Đánh giá - bình luận»: vẫn hiện form, khóa Vote / gửi bình luận. */
  const ratingCommentLocked = ratingCommentPerm.loaded && !ratingCommentPerm.canPost;
  const providerTitle = (() => {
    const name = (model?.name || "").trim();
    const code = (model?.code || "").trim();
    if (!name && !code) return "Thông tin nhà cung cấp";
    if (!code) return name;
    if (!name) return code;
    return `${name} - ${code}`;
  })();

  if (providerAccess === "denied") {
    return (
      <div>
        <AdLayout>
          <div className="container py-4">
            <div className="alert alert-warning mb-0">Truy cập không được phép.</div>
          </div>
        </AdLayout>
      </div>
    );
  }

  return (
    <div>
      <AdLayout>
        <div className="mt-2 container customer-management-page">
          <div className="card shadow-lg1 mb-3">
            <div className="block-header mb-2 position-relative">
              {model.id && (<span className="record_id">ID: {model.id}</span>)}
              <div className="department-page-header">
                <button
                  type="button"
                  className="department-page-header__back"
                  onClick={() => navigate(-1)}
                  aria-label="Quay lại"
                  title="Quay lại"
                >
                  <FiArrowLeft size={18} />
                </button>
                <div>{model.id ? providerTitle : 'Nhà cung cấp mới'}</div>
              </div>
            </div>
            <div className="d-none">
              <input type="hidden" id="ProviderId" value={model.id} />
              <input type="hidden" id="CommentUrl" value={`${API_URL_All}/api/providers/createProviderComment`} />
            </div>
            <ul className="nav nav-tabs">
              <li className="nav-item">
                <div className="tab-mini"></div>
              </li>
              <li className="nav-item">
                <a className={`nav-link ${activeTab === 'tab1' ? 'active' : ''}`} onClick={() => setActiveTab('tab1')}>Thông tin chung</a>
              </li>
              {model.id && (
                <li className="nav-item">
                  <a className={`nav-link ${activeTab === 'tab2' ? 'active' : ''}`} onClick={() => handleActiveTab('tab2')}>Danh sách sản phẩm</a>
                </li>
              )}
              {model.id && (
                <li className="nav-item">
                  <a className={`nav-link ${activeTab === 'tab3' ? 'active' : ''}`} onClick={() => setActiveTab('tab3')}>Lịch sử đặt hàng</a>
                </li>
              )}
              {model.id && (
                <li className="nav-item">
                  <a className={`nav-link ${activeTab === 'tab4' ? 'active' : ''}`} onClick={() => setActiveTab('tab4')}>Đánh giá</a>
                </li>
              )}
            </ul>

            <div className="">
              {activeTab === 'tab1' &&
                <div>
                  <form id="form_provider" className="form_validate" autoComplete="off" onSubmit={handleSubmitForm}>

                    <div className="container">
                      <div className="row ">
                        <div className="col-md-6 form-item mt-3">
                          <div className="row">
                            <label className="form-label col-form-label col-sm-4 col-4"><span className="required">Tên nhà cung cấp</span></label>
                            <div className="col-sm-8 col-8"><input name="name" placeholder="..." type="text" className="form-control" data-required="Phải nhập mục này" readOnly={!formWritable} value={model.name ?? ""} onChange={(e) => setModel({ ...model, name: e.target.value })} /></div>
                          </div>
                        </div>
                        <div className="col-md-6 form-item mt-3">
                          <div className="row">
                            <label className="form-label col-form-label col-sm-4  col-4">Mã nhà cung cấp</label>
                            <div className="col-sm-8  col-8"><input name="name" placeholder="..." type="text" className="form-control" readOnly={!formWritable} value={model.code ?? ""} onChange={(e) => setModel({ ...model, code: e.target.value })} /></div>
                          </div>
                        </div>

                        <div className="col-md-6 form-item mt-1">
                          <div className="row">
                            <label className="form-label col-form-label col-sm-4 col-4"><span className="">Người đại diện</span></label>
                            <div className="col-sm-8 col-8"><input name="name" placeholder="..." type="text" className="form-control" readOnly={!formWritable} value={model.personalName ?? ""} onChange={(e) => setModel({ ...model, personalName: e.target.value })} /></div>
                          </div>
                        </div>
                        <div className="col-md-6 form-item mt-1">
                          <div className="row">
                            <label className="form-label col-form-label col-sm-4  col-4">Điện thoại</label>
                            <div className="col-sm-8  col-8"><input name="name" placeholder="..." type="text" className="form-control" readOnly={!formWritable} value={model.phone ?? ""} onChange={(e) => setModel({ ...model, phone: e.target.value })} /></div>
                          </div>
                        </div>

                        <div className="col-md-6 form-item mt-1">
                          <div className="row">
                            <label className="form-label col-form-label col-sm-4 col-4"><span className="">Wechat</span></label>
                            <div className="col-sm-8 col-8"><input name="name" placeholder="..." type="text" className="form-control" readOnly={!formWritable} value={model.wechat ?? ""} onChange={(e) => setModel({ ...model, wechat: e.target.value })} /></div>
                          </div>
                        </div>
                        <div className="col-md-6 form-item mt-1">
                          <div className="row">
                            <label className="form-label col-form-label col-sm-4  col-4">Liên hệ khác</label>
                            <div className="col-sm-8  col-8"><input name="name" placeholder="..." type="text" className="form-control" readOnly={!formWritable} value={model.ortherContacting ?? ""} onChange={(e) => setModel({ ...model, ortherContacting: e.target.value })} /></div>
                          </div>
                        </div>
                      </div>

                      <div className="row">
                        <div className="col-md-12 form-item mt-1">
                          <div className="row">
                            <label className="form-label col-form-label col-sm-2  col-4">Địa chỉ</label>
                            <div className="col-sm-10 col-8"><input name="name" placeholder="..." type="text" className="form-control" readOnly={!formWritable} value={model.address ?? ""} onChange={(e) => setModel({ ...model, address: e.target.value })} /></div>
                          </div>
                        </div>
                        <div className="col-md-12 form-item mt-1">
                          <div className="row">
                            <label className="form-label col-form-label col-sm-2 col-4">Website</label>
                            <div className="col-sm-10 col-8"><input name="name" placeholder="..." type="text" className="form-control" readOnly={!formWritable} value={model.link ?? ""} onChange={(e) => setModel({ ...model, link: e.target.value })} /></div>
                          </div>
                        </div>
                        <div className="col-md-6 form-item mt-1">
                          <div className="row">
                            <label className="form-label col-form-label col-sm-4  col-4">Link taobao</label>
                            <div className="col-sm-8  col-8"><input name="name" placeholder="..." type="text" className="form-control" readOnly={!formWritable} value={model.link2 ?? ""} onChange={(e) => setModel({ ...model, link2: e.target.value })} /></div>
                          </div>
                        </div>
                        <div className="col-md-6 form-item mt-1">
                          <div className="row">
                            <label className="form-label col-form-label col-sm-4  col-4">Link 1688, ...</label>
                            <div className="col-sm-8  col-8"><input name="name" placeholder="..." type="text" className="form-control" readOnly={!formWritable} value={model.link3 ?? ""} onChange={(e) => setModel({ ...model, link3: e.target.value })} /></div>
                          </div>
                        </div>
                      </div>

                      <div className="row">
                        <div className="col-md-12 form-item">
                          <div className="row">
                            <label className="form-label col-form-label col-sm-2 col-4 col-max174">Nội dung quan trọng</label>
                            <div className="col-sm-10 col-8"><textarea name="name" placeholder="Năng lực, đặc điểm nhà cung cấp" type="text" className="form-control" readOnly={!formWritable} value={model.description ?? ""} onChange={(e) => setModel({ ...model, description: e.target.value })}></textarea></div>
                          </div>
                        </div>
                        <div className="col-md-12 form-item">
                          <div className="row">
                            <label className="form-label col-form-label col-sm-2 col-4 col-max174">Chính sách</label>
                            <div className="col-sm-10 col-8"><textarea name="name" placeholder="Trả trước, trả sau, theo từng đơn…" type="text" className="form-control" readOnly={!formWritable} value={model.policy??""} onChange={(e) => setModel({ ...model, policy: e.target.value })}></textarea></div>
                          </div>
                        </div>
                      </div>

                      <div className="row">
                        <div className="col-md-12 form-item mt-1">
                          <div className="row">
                            <label className="form-label col-form-label col-sm-2  col-4">File hồ sơ năng lực</label>
                            <div className="col-sm-8  col-8">
                              <div className="mb-3 relative">
                                <input id="FilePath" className="form-control form-control form-file" readonly="true" value={model.filePath ?? "Chưa chọn file nào"} />
                                {formWritable && <span className="select-file">Chọn file</span>}
                                <input type="file" className="d-none" data-select-for="FilePath"/>
                              </div>
                            </div>
                            <div className="col-sm-2">
                              {model.filePath && (
                                <span className="small-btn min-70 m-1" onClick={() => handleOpenPDF(model.filePath) }>Xem file</span>
                              )}                              
                            </div>
                          </div>
                        </div>
                      </div>

                      <div className="row">
                        <div className="col-md-12 form-item mt-1">
                          <div className="row">
                            <label className="form-label col-form-label col-sm-2 col-4">Người phụ trách</label>
                            <div className="col-sm-8 col-8">
                              {canEditCarePerson ? (
                                <select
                                  name="careId"
                                  className="form-control"
                                  value={model.careId ?? ""}
                                  onChange={(e) => {
                                    const nextId = e.target.value ? Number(e.target.value) : "";
                                    const picked = adminUsers.find((u) => Number(u.id) === Number(nextId));
                                    setModel({
                                      ...model,
                                      careId: nextId,
                                      careName: picked
                                        ? (picked.name || picked.username || picked.email || "")
                                        : "",
                                    });
                                  }}
                                >
                                  <option value="">— Chọn người phụ trách —</option>
                                  {model.careId &&
                                    !adminUsers.some((u) => Number(u.id) === Number(model.careId)) && (
                                      <option value={model.careId}>
                                        {model.careName || `User #${model.careId}`}
                                      </option>
                                    )}
                                  {adminUsers.map((u) => (
                                    <option key={u.id} value={u.id}>
                                      {u.name || u.username || u.email || `User #${u.id}`}
                                    </option>
                                  ))}
                                </select>
                              ) : (
                                <input
                                  type="text"
                                  className="form-control"
                                  readOnly
                                  value={carePersonDisplayName}
                                />
                              )}
                            </div>
                          </div>
                        </div>
                      </div>

                      <div className="text-center position-relative">
                        <div className="absolute-left">
                          {formWritable && model.id > 0 && model.active !== false && (
                            <button type="button" className="btn-small mt-2" onClick={() => handleDeletProvider()} >Ngừng hợp tác</button>
                          )}
                        </div>
                        {formWritable && (
                          <button type="submit" className="btn btn-sm btn-success m-2 d-inline-flex align-items-center gap-1">
                            <FaCheckCircle />
                            {model.active === false && <span>Khôi phục hoạt động</span>}
                            {model.active !== false && <span>Lưu dữ liệu</span>}
                          </button>
                        )}
                      </div>
                    </div>
                  </form>

                </div>
              }
              {activeTab === 'tab2' &&
                <div className="p-1">

                  <section className="">
                    <DataTable maxHeight="calc(100vh - 160px)" className="table-normal">
                      <table className="table table-striped table-bordered border-normal">
                        <thead className="table-primary">
                          <tr>
                            <th width="30px" className="sticky">STT</th>
                            <th width="150px"><span>Mã sản phẩm</span></th>
                            <th><span>Tên sản phẩm</span></th>
                            <th><span>Hình ảnh</span></th>
                            <th><span>Danh mục</span></th>
                            <th><span>Giá nhập </span><small className="fw-normal fst-italic">(báo khách)</small></th>

                            <th><span>Ghi chú</span></th>
                            <th width="100px" className="d-none">
                              <button className="btn btn-success btn-xs" onClick={() => openProductEditor(0)} title="Thêm sản phẩm">
                                <FaPlus />
                              </button>
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          {pageData.page && pageData.page.content && pageData.page.content.map((item, index) => (
                            <tr key={item.id}>
                              <td className="sticky" title={`productId: ${item.id}` }>{(pageData.page.number * pageData.page.size) + index + 1}</td>
                              <td className="text-start">{item.code}</td>
                              <td className="text-start">{item.name}</td>
                              <td width="100px" className="text-start over-visible">
                                <div className="img-incol">
                                  <img src={`${API_URL_All}/${item.imagePath}`} />
                                  <img className="popup-image" src={`${API_URL_All}/${item.imagePath}`} />
                                </div>
                              </td>
                              <td className="text-start">
                                {item.listCategoryNames && item.listCategoryNames.map((item2, index2) => (
                                  <div className="block-02" key={index2}>{item2}</div>
                                ))}
                              </td>
                              <td className="text-end">{item.price ? item.price.toLocaleString("vi-VN") : ""}</td>
                              <td className="text-start mw-200">{item.note}</td>
                              <td className="d-none">
                                <div>
                                  <FaPen className="text-primary me-2" onClick={() => openProductEditor(item.id)} size={15} title="Cập nhật" />
                                </div>
                              </td>
                            </tr>
                          ))}
                        </tbody>
                        <tbody>
                          {message === '' && loaded && pageData.page && pageData.page.content.length === 0 && (
                            <tr>
                              <td colSpan="11" className="text-center">Không có sản phẩm nào</td>
                            </tr>
                          )}
                          {message !== '' && (
                            <tr>
                              <td colSpan="11" className="text-center">{message}</td>
                            </tr>
                          )}
                        </tbody>
                      </table>
                    </DataTable>
                  </section>
                  <div className="mt-2 d-flex justify-content-end align-items-center">
                    <Paging
                      pageData={pageData}
                      onPageChange={handlePageChange}
                      onItemsPerPageChange={handleChangeItemsPerPage}
                    />
                  </div>
                </div>
              }
              {activeTab === 'tab3' &&
                <div>

                  <section className="p-1 ">
                    <DataTable maxHeight="calc(100vh - 220px)" className="table-normal">
                      <table className="table table-striped border-normal table-bordered">
                        <thead className="table-primary">
                          <tr>
                            <th className='sticky' width="21px">

                            </th>

                            <th>OrderId</th>
                            <th><span>Ngày</span></th>
                            <th>Mã vận đơn TQ</th>
                            <th>Tên sản phẩm</th>

                            <th>Số lượng</th>
                            <th className=""><span data-note="CNY">Giá NCC</span></th>

                            <th className="text-start d-none"><span data-note="vnđ">Thành tiền</span></th>
                            <th className="text-center d-none"><span data-note="">Gói cước</span></th>
                            <th className="text-center d-none"><span data-note="">Cước phí</span></th>

                          </tr>
                        </thead>
                        {pageOrderData.page && pageOrderData.page.content && pageOrderData.page.content.map((item, index) => (
                          <tbody className="tbody-row">
                            <tr key={index}>
                              <td className="sticky" title={`orderId: ${item.orderId}`}>{(pageOrderData.page.number * pageOrderData.page.size) + index + 1}</td>
                              <td className="text-success">{item.orderId}</td>
                              <td className="text-success" title={general.formatTimeShort(item.orderDate)}>{general.formatDate(item.orderDate)}</td>
                              <td className="text-success text-start">{item.cnCode}</td>
                              <td className="text-success text-start">{item.productName}</td>

                              <td className="text-success text-center">{item.quantityText}</td>
                              <td className="text-success text-end">{general.formatNumber(item.priceIn)}</td>

                              <td className="text-success text-end d-none">{general.formatNumber(item.money)}</td>
                              <td className="text-success text-center d-none">{getWeightSize(item.weight, item.feeWeight, item.size, item.feeSize)}</td>
                              <td className="text-success text-end d-none">{general.formatNumber(item.fee)}</td>

                            </tr>
                          </tbody>
                        ))}


                        <tbody>
                          {errorMessage === '' && loaded && pageOrderData.page && pageOrderData.page.content.length === 0 && (
                            <tr>
                              <td colSpan="21" className="text-center">Không có đơn hàng nào</td>
                            </tr>
                          )}
                          {errorMessage !== '' && (
                            <tr>
                              <td colSpan="21" className="text-center">{errorMessage}</td>
                            </tr>
                          )}
                        </tbody>
                      </table>
                    </DataTable>
                  </section>
                  <div className="mt-2 d-flex justify-content-end align-items-center">
                    <Paging
                      pageData={pageOrderData}
                      onPageChange={handleOrderPageChange}
                      onItemsPerPageChange={handleOrderSizeChange}
                    />
                  </div>
                </div>
              }
              {activeTab === 'tab4' &&
                <div>

                  {model.id && (
                    <div className="container pt-3">
                      <div className="row">
                        <div className="col-md-12">
                          <div className="group-box" data-text="Chất lượng nhà cung cấp">
                            <div className="row">
                              <div className="col-md-6">
                                <div className="mt-2">
                                  <span>Số đơn hàng: <b>{general.formatNumber(model.orderCount)}</b></span>
                                </div>
                                <div className="mt-2">
                                  <span>Tổng thanh toán: <b>{general.formatNumber(model.orderMoney)}</b> vnđ</span>
                                </div>
                                <div className="mt-2 d-none">
                                  <span className="label-01">Đánh giá: </span> <StarRating rating={model.star ?? 0} />
                                </div>
                              </div>
                              <div className="col-md-6 ">
                                <div className="mt-2">
                                  <span className="label-01">Giá cả:</span> <StarRating rating={model.starPrice ?? 0} />
                                </div>
                                <div className="mt-2">
                                  <span className="label-01">Chất lượng: </span> <StarRating rating={model.starProduct ?? 0} />
                                </div>
                                <div className="mt-2">
                                  <span className="label-01">Tiến độ:</span> <StarRating rating={model.starProcess ?? 0} />
                                </div>
                              </div>
                            </div>
                          </div>

                        </div>
                      </div>


                      <div className ="frame-feedback">
                        <div className="frame-result flex">
                          <div className="col">
                            <span className="like-num-over d-none">
                              <span>
                                <span className="img-like">
                                  <img height="18" role="presentation" width="18" src="data:image/svg+xml,%3Csvg fill='none' xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'%3E%3Cpath d='M16.0001 7.9996c0 4.418-3.5815 7.9996-7.9995 7.9996S.001 12.4176.001 7.9996 3.5825 0 8.0006 0C12.4186 0 16 3.5815 16 7.9996Z' fill='url(%23paint0_linear_15251_63610)'/%3E%3Cpath d='M16.0001 7.9996c0 4.418-3.5815 7.9996-7.9995 7.9996S.001 12.4176.001 7.9996 3.5825 0 8.0006 0C12.4186 0 16 3.5815 16 7.9996Z' fill='url(%23paint1_radial_15251_63610)'/%3E%3Cpath d='M16.0001 7.9996c0 4.418-3.5815 7.9996-7.9995 7.9996S.001 12.4176.001 7.9996 3.5825 0 8.0006 0C12.4186 0 16 3.5815 16 7.9996Z' fill='url(%23paint2_radial_15251_63610)' fill-opacity='.5'/%3E%3Cpath d='M7.3014 3.8662a.6974.6974 0 0 1 .6974-.6977c.6742 0 1.2207.5465 1.2207 1.2206v1.7464a.101.101 0 0 0 .101.101h1.7953c.992 0 1.7232.9273 1.4917 1.892l-.4572 1.9047a2.301 2.301 0 0 1-2.2374 1.764H6.9185a.5752.5752 0 0 1-.5752-.5752V7.7384c0-.4168.097-.8278.2834-1.2005l.2856-.5712a3.6878 3.6878 0 0 0 .3893-1.6509l-.0002-.4496ZM4.367 7a.767.767 0 0 0-.7669.767v3.2598a.767.767 0 0 0 .767.767h.767a.3835.3835 0 0 0 .3835-.3835V7.3835A.3835.3835 0 0 0 5.134 7h-.767Z' fill='%23fff'/%3E%3Cdefs%3E%3CradialGradient id='paint1_radial_15251_63610' cx='0' cy='0' r='1' gradientUnits='userSpaceOnUse' gradientTransform='rotate(90 .0005 8) scale(7.99958)'%3E%3Cstop offset='.5618' stop-color='%230866FF' stop-opacity='0'/%3E%3Cstop offset='1' stop-color='%230866FF' stop-opacity='.1'/%3E%3C/radialGradient%3E%3CradialGradient id='paint2_radial_15251_63610' cx='0' cy='0' r='1' gradientUnits='userSpaceOnUse' gradientTransform='rotate(45 -4.5257 10.9237) scale(10.1818)'%3E%3Cstop offset='.3143' stop-color='%2302ADFC'/%3E%3Cstop offset='1' stop-color='%2302ADFC' stop-opacity='0'/%3E%3C/radialGradient%3E%3ClinearGradient id='paint0_linear_15251_63610' x1='2.3989' y1='2.3999' x2='13.5983' y2='13.5993' gradientUnits='userSpaceOnUse'%3E%3Cstop stop-color='%2302ADFC'/%3E%3Cstop offset='.5' stop-color='%230866FF'/%3E%3Cstop offset='1' stop-color='%232B7EFF'/%3E%3C/linearGradient%3E%3C/defs%3E%3C/svg%3E" />
                                </span>
                                <span className="like_num">40</span>
                              </span>
                            </span>
                          </div>
                          <div className="col text-end">
                            <span>{pageCommentsData.page && pageCommentsData.page.totalElements} bình luận</span>
                          </div>
                        </div>

                        <div className="frame-actions">
                          <div className="flex">
                            <div className="col">
                              <span className="frame-act like_post d-none">
                                <span className="icon-over">
                                  <i className="icon-like"></i>
                                </span>
                                <span className="post-t">Thích</span>
                              </span>
                            </div>
                            <div className="col">
                              <span
                                className={`frame-act comment_post${ratingCommentLocked ? " opacity-50" : ""}`}
                                role="button"
                                title={ratingCommentLocked ? "Không có quyền đánh giá / bình luận" : undefined}
                                style={{ cursor: ratingCommentLocked ? "not-allowed" : "pointer" }}
                                onClick={(e) => {
                                  if (ratingCommentLocked) {
                                    e.preventDefault();
                                    toast.warning("Bạn không có quyền đánh giá và bình luận nhà cung cấp.");
                                    return;
                                  }
                                  openVoteEditor();
                                }}
                              >
                                <span className="icon-over">
                                  <i className="icon-comment"></i>
                                </span>
                                <span className="post-t ">Vote</span>
                              </span>
                            </div>
                            <div className="col">
                              <span className="frame-act d-none">
                                <span className="icon-over">
                                  <i className="icon-share"></i>
                                </span>
                                <span className="post-t">Chia sẻ</span>
                              </span>
                            </div>
                          </div>
                        </div>

                        <div className="auto_group frame-comment d-none1">
                          <div className=" frame-comments">
                            {comments && comments.map((item, index) => (

                              <div className="frame-com-item flex" key={index} data-comment-id={item.id}>
                                <div className="per-avatar02">
                                  <img src={item.userPath} />
                                </div>
                                <div className="fill com_item_box">
                                  <div className="com-lv1">
                                    <div className="frame-com-mes">
                                      <b>{item.userFullname}</b>
                                      {item.star > 0 && (
                                        <div><StarRating rating={item.star} /></div>
                                      )}
                                      <div>{item.content}</div>
                                    </div>
                                    <div>
                                      <div className="frame-com-acts flex">
                                        <span className="frame-time">{general.formatDate(item.insertTime)}</span>
                                        <span className="frame-like like_com d-none">Like</span>
                                        <span className="frame-reply reply_com">Reply</span>
                                        <span className="like_com_num_over box-like d-none">
                                          <span>
                                            <span className="img-like ">
                                              <img height="18" role="presentation" width="18" src="data:image/svg+xml,%3Csvg fill='none' xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'%3E%3Cpath d='M16.0001 7.9996c0 4.418-3.5815 7.9996-7.9995 7.9996S.001 12.4176.001 7.9996 3.5825 0 8.0006 0C12.4186 0 16 3.5815 16 7.9996Z' fill='url(%23paint0_linear_15251_63610)'/%3E%3Cpath d='M16.0001 7.9996c0 4.418-3.5815 7.9996-7.9995 7.9996S.001 12.4176.001 7.9996 3.5825 0 8.0006 0C12.4186 0 16 3.5815 16 7.9996Z' fill='url(%23paint1_radial_15251_63610)'/%3E%3Cpath d='M16.0001 7.9996c0 4.418-3.5815 7.9996-7.9995 7.9996S.001 12.4176.001 7.9996 3.5825 0 8.0006 0C12.4186 0 16 3.5815 16 7.9996Z' fill='url(%23paint2_radial_15251_63610)' fill-opacity='.5'/%3E%3Cpath d='M7.3014 3.8662a.6974.6974 0 0 1 .6974-.6977c.6742 0 1.2207.5465 1.2207 1.2206v1.7464a.101.101 0 0 0 .101.101h1.7953c.992 0 1.7232.9273 1.4917 1.892l-.4572 1.9047a2.301 2.301 0 0 1-2.2374 1.764H6.9185a.5752.5752 0 0 1-.5752-.5752V7.7384c0-.4168.097-.8278.2834-1.2005l.2856-.5712a3.6878 3.6878 0 0 0 .3893-1.6509l-.0002-.4496ZM4.367 7a.767.767 0 0 0-.7669.767v3.2598a.767.767 0 0 0 .767.767h.767a.3835.3835 0 0 0 .3835-.3835V7.3835A.3835.3835 0 0 0 5.134 7h-.767Z' fill='%23fff'/%3E%3Cdefs%3E%3CradialGradient id='paint1_radial_15251_63610' cx='0' cy='0' r='1' gradientUnits='userSpaceOnUse' gradientTransform='rotate(90 .0005 8) scale(7.99958)'%3E%3Cstop offset='.5618' stop-color='%230866FF' stop-opacity='0'/%3E%3Cstop offset='1' stop-color='%230866FF' stop-opacity='.1'/%3E%3C/radialGradient%3E%3CradialGradient id='paint2_radial_15251_63610' cx='0' cy='0' r='1' gradientUnits='userSpaceOnUse' gradientTransform='rotate(45 -4.5257 10.9237) scale(10.1818)'%3E%3Cstop offset='.3143' stop-color='%2302ADFC'/%3E%3Cstop offset='1' stop-color='%2302ADFC' stop-opacity='0'/%3E%3C/radialGradient%3E%3ClinearGradient id='paint0_linear_15251_63610' x1='2.3989' y1='2.3999' x2='13.5983' y2='13.5993' gradientUnits='userSpaceOnUse'%3E%3Cstop stop-color='%2302ADFC'/%3E%3Cstop offset='.5' stop-color='%230866FF'/%3E%3Cstop offset='1' stop-color='%232B7EFF'/%3E%3C/linearGradient%3E%3C/defs%3E%3C/svg%3E" />
                                            </span>
                                            <span className="like_com_num">1</span>
                                          </span>
                                        </span>
                                      </div>

                                    </div>
                                  </div>

                                  <div className="frame-subcom">
                                    <div className="sub-comments">
                                      {item.children && item.children.map((sub, subIndex) => (

                                        <div className="frame-com-item flex" key={subIndex}>
                                        <div className="per-avatar03">
                                            <img src={sub.userPath} />
                                        </div>
                                        <div>
                                          <div className="frame-com-mes">
                                              <b>{sub.userFullname}</b>
                                              <div>{sub.content}</div>
                                          </div>
                                          <div className="frame-com-acts">
                                            <span className="frame-time">{general.formatDate(item.insertTime)}</span>
                                            <span className="frame-reply reply_com">Reply</span>
                                          </div>
                                        </div>
                                      </div>
                                      ))}
                                    </div>

                                  </div>
                                </div>
                              </div>
                            ))}

                          </div>
                          {!ratingCommentLocked && (
                            <div className="comment-form">
                              <div className="per-avatar02">
                                <img src={config.userPath} alt="" />
                              </div>
                              <div className="fill frame-com-box">
                                <div className="fill com-textarea-over">
                                  <textarea
                                    placeholder="Bình luận của bạn"
                                    className="auto-area post_com"
                                    rows="1"
                                  />
                                </div>
                                <div className="com-button-over">
                                  <button type="button" className="submit-btn no-bg send_com">
                                    <svg className="xsrhx6k" height="20px" viewBox="0 0 24 24" width="20px">
                                      <title>Press Enter to send</title>
                                      <path d="M16.6915026,12.4744748 L3.50612381,13.2599618 C3.19218622,13.2599618 3.03521743,13.4170592 3.03521743,13.5741566 L1.15159189,20.0151496 C0.8376543,20.8006365 0.99,21.89 1.77946707,22.52 C2.41,22.99 3.50612381,23.1 4.13399899,22.8429026 L21.714504,14.0454487 C22.6563168,13.5741566 23.1272231,12.6315722 22.9702544,11.6889879 C22.8132856,11.0605983 22.3423792,10.4322088 21.714504,10.118014 L4.13399899,1.16346272 C3.34915502,0.9 2.40734225,1.00636533 1.77946707,1.4776575 C0.994623095,2.10604706 0.8376543,3.0486314 1.15159189,3.99121575 L3.03521743,10.4322088 C3.03521743,10.5893061 3.34915502,10.7464035 3.50612381,10.7464035 L16.6915026,11.5318905 C16.6915026,11.5318905 17.1624089,11.5318905 17.1624089,12.0031827 C17.1624089,12.4744748 16.6915026,12.4744748 16.6915026,12.4744748 Z" fill="var(--chat-composer-button-color)"></path>
                                    </svg>
                                  </button>
                                </div>
                              </div>
                            </div>
                          )}
                        </div>

                      </div>
                    </div>
                  )}
              </div>
              }
            </div>
            <div className="p-1"></div>

              </div>
          </div>

        <input type="hidden" id="editor_stars" value="1 sao,2 sao,3 sao,4 sao,5 sao" />
        {productEditorData && (
          <ProductEditor data={productEditorData} handleSearch={searchProducts} />
        )}
        {voteEditorData && (
          <VoteEditor data={voteEditorData} handleSearch={refreshTabComment} />
        )}
      </AdLayout>
    </div>
  );
};

export default Provider;
